import styled from 'styled-components';

import { TextInput as TextInputComponent } from '@prisjakt/ui-inputs';

export const TextInput = styled(TextInputComponent)`
  input,
  input:focus {
    border: 0;
    box-shadow: none;
  }
`;
